<template>
  <div id="users" class="px-4">
    <user-list />
  </div>
</template>
<script>
import UserList from "@/components/user_management/UserList.vue";
export default {
  components: {
    UserList
  }
};
</script>
